import { gql } from "@apollo/client";

export const getPayBillByScheduleIdQuery = gql`
query($scheduleId: String!){
  getPayBill(scheduleId: $scheduleId) {
    message
    response
  }
}
`;